import React from 'react';
import UserHeader from './UserHeader';

function MessageItem({ item, showUser }) {
    const isGodFather = item.user.role.name == 'GodFather';
    const gfItemContainer = isGodFather ? 'tchat_gfItemContainer' : '';
    const eliminatedGroup = item.eliminatedMsg ? 'tchat_eliminatedGroup' : '';

    return (
        <div className={`tchat_item ${gfItemContainer} ${eliminatedGroup}`}>
            { showUser && <UserHeader userName={item.user.name} isGodFather={isGodFather} /> }
            <p className='tchat_msgItem'>{item.msg}</p>
        </div>
    );
}

export default React.memo(MessageItem);